const surveyRQKeys = {
  all: ['survey'],
  list: () => [...surveyRQKeys.all, 'list'],
  previews: () => [...surveyRQKeys.list(), 'previews'],
  details: () => [...surveyRQKeys.all, 'detail'],
  detail: (id) => [...surveyRQKeys.details(), id]
}

export default surveyRQKeys
